import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import useServiceRequestHandler from "./useServiceRequestHandler";
import useSocket from "./useSocket";

import {
  newNotificationReceived,
  markNotificationSeen
} from "../../../redux/actions/notifications.actions";
import { openNotificationService } from "../../../components/Notifications/notificationOpeners";
import history from "../../../history";

const TOAST_OPTIONS = {
  autoClose: 4000,
  closeOnClick: false,
  draggable: false,
  theme: "colored"
};

// Toast copy + click-through route per notification type (service_requests
// has its own richer handler below).
const TYPE_TOASTS = {
  tickets: {
    text: "You've been assigned to a new service.",
    route: "/services"
  },
  service_messages: { text: "New message on a service.", route: "/services" },
  service_request_messages: {
    text: "New message on a service request.",
    route: "/service-requests"
  },
  service_comments: {
    text: "New comment on a service.",
    route: "/services"
  }
};

export default function useNotifications() {
  const dispatch = useDispatch();
  const { handleServiceRequest } = useServiceRequestHandler();

  const handleNewNotification = useCallback(
    ({ data, type }) => {
      // Payload carries the created notification row — feed the in-app
      // notification center (badge + list) for every type.
      const notification = data?.notification;
      if (notification) {
        dispatch(newNotificationReceived(notification));
      }

      if (type === "service_requests") {
        handleServiceRequest(notification);
        return;
      }

      const toastConfig = TYPE_TOASTS[type];
      if (!toastConfig) {
        console.warn(`Unhandled notification type: ${type}`);
        return;
      }

      toast.info(
        <div
          onClick={() => {
            // Open the service drawer in place; fall back to the old
            // list-page navigation if the payload can't be resolved.
            if (openNotificationService(dispatch, notification)) {
              dispatch(markNotificationSeen(notification.id));
            } else {
              history.push(toastConfig.route);
            }
            toast.dismiss();
          }}
        >
          {toastConfig.text}
        </div>,
        TOAST_OPTIONS
      );
    },
    [dispatch, handleServiceRequest]
  );

  useSocket(handleNewNotification);
}
